import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, portal, isInitialLoading } = useAuth();

  if (isInitialLoading) {
    return null;
  }

  if (!isAuthenticated || !portal) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
